import { api } from "../../app/api";
import { command } from "../../app/command";
import { query } from "../../app/query";
import { EventPayload } from "../../common/types/Event";
import { Options } from "../../common/types/requestOptions";
import {
  AddUserMessageRecipientsBody,
  AttachmentDownloadUrlParams,
  AttachmentDownloadUrlResponse,
  AttachmentUploadUrlParams,
  AttachmentUploadUrlResponse,
  CreateUserMessageBody,
  StartUserMessageProcessingBody,
  UserMessageByIdParams,
  UserMessageByIdResponse,
  UserMessagesQueryParams,
  UserMessagesResponse,
} from "./userMessagesTypes";

export const createUserMessageCmd = (
  body: CreateUserMessageBody,
  options: Options,
): Promise<EventPayload<unknown>[]> =>
  command("/identity/cmd/createUserMessage", body, options);

export const addUserMessageRecipientsCmd = (
  body: AddUserMessageRecipientsBody,
  options: Options,
): Promise<EventPayload<unknown>[]> =>
  command("/identity/cmd/addUserMessageRecipients", body, options);

export const startUserMessageProcessingCmd = (
  body: StartUserMessageProcessingBody,
  options: Options,
): Promise<EventPayload<unknown>[]> =>
  command("/identity/cmd/startUserMessageProcessing", body, options);

export const uploadUserMessageAttachmentToS3 = (
  url: string,
  file: File,
): Promise<unknown> =>
  api.upload(url, { headers: { "Content-Type": file.type }, body: file });

export const getUserMessagesQry = (
  params: UserMessagesQueryParams,
  options: Options,
): Promise<UserMessagesResponse> =>
  query<UserMessagesQueryParams, UserMessagesResponse>(
    "/identity/qry/userMessages",
    // TODO: Some kind of pagination is needed here
    { recipientUserId: params.recipientUserId, limit: params.limit ?? 500 },
    options,
  );

export const getUserMessageByIdQry = (
  params: UserMessageByIdParams,
  options: Options,
): Promise<UserMessageByIdResponse> =>
  query<UserMessageByIdParams, UserMessageByIdResponse>(
    "/identity/qry/userMessageById",
    params,
    options,
  );

export const getAttachmentUploadUrlQry = (
  params: AttachmentUploadUrlParams,
  options: Options,
): Promise<AttachmentUploadUrlResponse> =>
  query<AttachmentUploadUrlParams, AttachmentUploadUrlResponse>(
    "/identity/qry/userMessageAttachmentUploadUrl",
    params,
    options,
  );

export const getAttachmentDownloadUrlQry = (
  params: AttachmentDownloadUrlParams,
  options: Options,
): Promise<AttachmentDownloadUrlResponse> =>
  query<AttachmentDownloadUrlParams, AttachmentDownloadUrlResponse>(
    "/identity/qry/userMessageAttachmentDownloadUrl",
    params,
    options,
  );
